module.exports = __webpack_public_path__ + "static/media/fortmatic.176290a2.svg";